import Vue from 'vue'
import './plugins/axios'
import './plugins/vue-cookie'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import ElementUI from 'element-ui'
import '@/style/styles.scss'
import '@/icon/iconfont.scss'
import moment from 'moment'

import VueImageSwipe from 'vue-image-swipe'
import 'vue-image-swipe/dist/vue-image-swipe.css'
import 'nprogress/nprogress.css'// Progress 进度条 样式

import HD_UI from '@/components'
import NProgress from 'nprogress' // Progress 进度条

import Print from '@/plugins/print'
import * as filters from './utils/filters.js'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])// 插入过滤器名和对应方法
})

Vue.use(Print) // 注册

Vue.use(VueImageSwipe)
Vue.use(HD_UI)

Vue.use(ElementUI)

Vue.config.productionTip = true
Vue.prototype.$moment = moment
moment.locale('zh-cn')

Vue.prototype.FormatDate = strTime => {
  let date = new Date(strTime)
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
}

router.beforeEach(async (to, from, next) => {
  NProgress.start() // 开启Progress
  if (store.getters.token) {
    // 调用公司情况的
    if (store.state.company.companyList.length === 0) {
      await store.dispatch('getCompanyList')
    }
    // 没有数据的时候调用
    if (!store.state.user.tipsNumber) {
      let flag = false
      if (store.state.permission.loadmenu.length) {
        store.state.permission.loadmenu.forEach(item => {
          if (item.path === '/msg') {
            flag = true
          }
        })
      }
      if (flag) {
        // 有待办事项这个路由就调用下面的接口
        await store.dispatch('GetNeedToTips')
      }
    }

    // 当时是动端的时候，跳转路由关闭导航
    if (!store.getters.tagsView) {
      store.commit('SET_ISACTIVE', false)
    }
    // 判断是否登录
    if (to.path === '/login') next({ path: '/' })
    else {
      // 如果有路由表以后直接操作 防止一直触发
      if (store.getters.addRouters.length > 0) {
        next()
      } else {
        // 没有的时候进行添加
        const accessRoutes = await store.dispatch('Loadmenu')
        router.addRoutes(accessRoutes)
        if (JSON.stringify(store.getters.userPerms) !== '{}') {
          next({ ...to, replace: true })
        } else {
          await store.dispatch('loadperms')
          next({ ...to, replace: true })
        }
      }
    }
  } else {
    if (to.path !== '/login') {
      next('/login')
    }
    next()
    NProgress.done()
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})

// 异常处理问题
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  if (isChunkLoadFailed) {
    router.replace(targetPath)
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
